module.exports = __webpack_public_path__ + "static/img/succeed.f7cc904c.png";